module.exports = "   agm-map {\n    height: 380px;\n    width:100%;\n    display:block;    \n  }"